import { environment } from '../environment';

export const AMOUNT_VALUE_FIELD_STEP = Math.pow(
  10,
  environment.amountMaximumFractionDigits * -1,
);

export const QUANTITY_VALUE_FIELD_STEP = Math.pow(
  10,
  environment.quantityMaximumFractionDigits * -1,
);
